export function objectHasId(value: object): value is { id: string } {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}
